import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "5311aa91-d578-4c36-9d92-b8a39a9af24f",
        authority: "https://login.microsoftonline.com/2f37307c-b165-45ea-a717-caf228c409ab"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ["api://simsbat.solugrowth.com/SIMSUser.read"]
};